<style scoped>
  .post-wrapper {
    background-color: white;
    height: auto;
    width: 100%;
    overflow: hidden;
  }
  .post-body {
    /* margin-top: 80px; */
    /* border-top:1px solid #ddd; */
    height: calc(100% - 150px);
    width: 100%;
    overflow-y: scroll;
    padding: 0 15px 0 15px;
  }
  .post-footer {
    /* position: relative; */
    background-color: white;
    position: fixed;
    bottom: 0;
    height: 70px;
    width: 100%;
    border-top: 1px solid rgb(190, 190, 190);
    /* padding: 10px 0 10px 10px; */
    padding: 10px;
    display: flex;
  }
  .view-previous {
    font-size:14px;
    padding:0 0 5px 45px;
  }
  textarea {
    height: 45px !important;
    border: none;
    overflow: hidden;
    outline: none;
    width:100%;
    padding:10px 0 0 10px;
    height:80%;
    margin: 0 5px 0 5px;
    resize: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  Button {
    padding:0px !important;
  }
  .post-line {
    display: flex;
    margin-bottom: 10px;
  }
  .post-col1 {
    display: flex;
  }
  .post-col2 {
    padding-left: 10px;
    width: 100%;
  }
  .status {
    font-size:10px;
  }

</style>


<template>
  <div class="post-wrapper">
    <!-- <BeFirstToComponent v-show="!hasComment">Be the first to comment</BeFirstToComponent> -->
    <div class="post-body">
      <PostComponent v-for="(activity,index) in activities" @showLike="showLikeModal"
        :type="'comment'"
        :indentIt=false
        :key="index"
        :index="index"
        :activityId="activity.id"
        :userAvatar="activity.user.avatar"
        :userDisplayName="activity.user.display_name"
        :content="activity.content"
        :updatedAt="activity.date_recorded"
        :likesTotal="activity.likes.total"
        :userId="activity.user.id"
        :hasReply=true
        >
          <!--
          <p :id="'clickPrevious' + index" class="view-previous" v-show="activity.comment.total>1">
            <a @click="viewPrevious(index)">View {{activity.comment.total-1}} previous replies</a>
          </p>
          <PostComponent v-show="activity.comment.total>=1" @showLike="showLikeModal"
            v-for="(comment,indexReply) in comments(activity.comment.comments, true)"
            :type="'reply'"
            :indentIt=true
            :key="indexReply"
            :index="index"
            :indexReply="indexReply"
            :activityId="comment.id"
            :userAvatar="comment.user.avatar"
            :userDisplayName="comment.user.display_name"
            :content="comment.content"
            :updatedAt="comment.date_recorded"
            :likesTotal="comment.likes.total"
            :userId="comment.user.id"
            :hasReply=false
            >
          </PostComponent>

          <div :id="'viewPrevious' + index" style="display:none">
            <PostComponent
              v-for="(comment,indexReply) in comments(activity.comment.comments, false)"
              :type="'reply'"
              :indentIt=true
              :key="indexReply++"
              :index="index"
              :indexReply="indexReply++"
              :activityId="comment.id"
              :userAvatar="comment.user.avatar"
              :userDisplayName="comment.user.display_name"
              :content="comment.content"
              :updatedAt="comment.updated_at"
              :likesTotal="comment.likes.total"
              :userId="comment.user.id"
              :hasReply=false
              >
            </PostComponent>
          </div> -->


      </PostComponent>

    </div>
    <div class="post-footer">
      <Avatar size="large" :src="userInfo.avatar" style="height:40px; width:50px; margin:-5px 0 0 5px;" ></Avatar>
      <textarea v-model="reply" id="reply" placeholder="Write a comment" cols="30" rows="2" style=""></textarea>
      <Button v-show="hasReply && !isReplying" @click="postComment()" type="text" ><Icon type="android-send" size="30"/> </Button>
      <Button v-show="!hasReply && !isReplying" type="text" disabled><Icon type="android-send" size="30"/> </Button>
      <Button v-show="hasReply && isReplying" type="text" loading disabled></Button>
    </div>

    <ModalHolder :title="'Likes'" :closable="false" m-top="0" :is-show="showLikes">
        <template slot="mcontent">
          <div class="modal-container">
            <Card v-for="(like, i) in likes" class="card" :key="i" :bordered="false" dis-hover :padding="0">
              <div class="post-line">
                <div class="post-col1">
                  <router-link tag="div" :to="'/profile/'+ like.id">
                    <Avatar size="large" :src="like.avatar"></Avatar>
                  </router-link>
                </div>
                <div class="post-col2">
                  <p>
                    <router-link tag="div" :to="'/profile/'+ like.id">
                      <b style="color:black;"> {{ like.display_name }} </b>
                    </router-link>
                  </p>
                  <p class="status">
                    <timeago :since="like.updated_at"></timeago>
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </template>
        <template slot="mfooter">
            <Button type="default" long @click="showLikes=false">Close</Button>
        </template>
    </ModalHolder>

  </div>

</template>


<script>
import BeFirstToComponent from '@/components/BeFirstToComponent';
import PostComponent from '@/components/PostComponent';
import ModalHolder  from "@/components/ModalHolderComponent";
import _ from "lodash";



export default {
  name: "FeedSingleCommentComponent",
  components: {
    BeFirstToComponent, PostComponent, ModalHolder
  },
  data() {
    return {
      index: undefined,
      indexReply: undefined,
      showLikes: false,
			hasReply: false,
      reply: ""
    }
	},
	watch: {
		"reply": function() {
			if (this.reply!=undefined) {
				this.hasReply = this.reply.trim().length>0;
			}
		}
	},
  computed: {
    likes: {
      get() {
        if (this.index==undefined && this.indexReply==undefined) {
          return [];
        } else if (this.indexReply==undefined) {
          return this.activities[this.index].likes.users;
        } else {
          return this.activities[this.index].comment.comments[this.indexReply].likes.users;
        }
      }
    },
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    currentUserId: {
      get() {
        return this.$store.state.user.info.id;
      }
		},
		hasComment: {
			get() {
				var has = false;
				if (this.activities!=undefined) {
					has = this.activities.length>0
				}
				return has;
			}
		},
    activities: {
      get() {
        return this.$store.state.feed.feedSingleItemActivities.activities;
      }
    },
    isReplying: {
      get() {
        return this.$store.state.feed.isReplying;
      }
    }
  },
  mounted() {
        this.$store.dispatch('feed/getFeedSingleItemActivities', this.$route.params.activityID)
  },
  methods: {
    showLikeModal: function(value) {
      console.log(value);
      this.index=value.index;
      this.indexReply=value.indexReply;
      this.showLikes=true;
    },
    postComment() {
      var param = {
        content: this.reply,
        item_id: this.$route.params.activityID
      };
      this.$store.dispatch("feed/postFeedSingleComment", param);
      this.reply="";
    },
    comments: function(list, latest) {
      if (latest) return (list.length>1) ? [_.head(list)]: list;
      if (list.length==0) return list;
      var clone =_.clone(list, true);
      clone.splice(0,1);
      return clone;
    },
    viewPrevious: function(index) {
      document.getElementById("viewPrevious"+index).style["display"] = null;
      document.getElementById("clickPrevious"+index).style.display="none";
    }
  }

}

</script>
